import { createContext } from 'react';
import _noop from 'lodash/noop';

export const PaymentPlanStatusContext =
    createContext<PaymentPlanStatusProviderValue>({
        canUploadDetections: false,
        chargebeePlanSettings: null,
        fetchChargebeeSubscriptionSettings: _noop,
        fetchTrqkUserSubscriptionSettings: _noop,
        isPublisherEdition: false,
        quarterlyRunRate: null,
        setSubscriptionSettings: _noop,
        showFreeTrialFooter: false,
        subscriptionId: null,
        subscriptionSettings: null,
        usage: {
            detectionTracks: {
                capacity: 0,
                exceedsCapacity: false,
                used: 0,
            },
            exceedsCapacity: false,
            royalties: {
                capacity: 0,
                exceedsCapacity: false,
                used: 0,
            },
        },
    });
